import { GQL_ID, TextMaterial } from '@@types'
import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_TEXT_MATERIAL } from '../fragments'

type SingleTextMaterialQuery = {
  singleTextMaterial: TextMaterial
}

type SingleTextMaterialVariables = {
  id?: GQL_ID
  slug?: string
}

export const GQL_QUERY_SINGLE_TEXT_MATERIAL = gql`
  query singleTextMaterial($id: ID, $slug: String) {
    singleTextMaterial(id: $id, slug: $slug) {
      ${SHORTCUT_TEXT_MATERIAL}
    }
  }
`

export const useFetchSingleTextMaterial = (variables: SingleTextMaterialVariables) => {
  const { data, loading, error, refetch } = useQuery<SingleTextMaterialQuery, SingleTextMaterialVariables>(
    GQL_QUERY_SINGLE_TEXT_MATERIAL,
    {
      variables,
      fetchPolicy: 'cache-and-network',
      skip: !variables.id && !variables.slug
    }
  )

  const singleTextMaterial = data?.singleTextMaterial

  return {
    singleTextMaterial,
    data,
    loading,
    error,
    refetch
  }
}